import axios from "axios"

export type Article = {
    ID: number,
    Name: string,
    Description: string,
    ArticleSources: Source[],
    ArticleImages: ArticleImage[],
    ArticleCategories: {
        category_id: number
    }[]
    Author: string,
    Tags: string,
    ArticleLanguage?: any,
    ArticleSourceLanguage?: any
}

export type ArticleImage = {
    ID: number
    Url: string
}

export type Source = {
    ID: number;
    Url: string;
    Number: number;
}


export async function createArticle(articleObject: any, language: any): Promise<boolean>{

    return new Promise((resolve, reject) => {
        axios.post('articles', {articleObject, language}).then(res => {
            resolve(res.data)
        }).catch(err => reject(err))
    })

}

export async function updateArticle(id: number, articleObject: any, language: any): Promise<boolean>{

    return new Promise((resolve, reject) => {
        axios.patch(`articles/${id}`, {articleObject, language}).then(res => {
            resolve(res.data)
        }).catch(err => reject(err))
    })

}

export async function removeArticle(id: number): Promise<boolean>{

    return new Promise((resolve, reject) => {
        axios.delete(`articles/${id}`).then(res => {
            resolve(res.data)
        }).catch(err => reject(err))
    })

}


export async function getArticles(): Promise<Article[]> {
    return new Promise((resolve, reject) => {
        axios.get('articles').then(res => {
            resolve(res.data)
        }).catch(err => reject(err))
    })
}


export async function uploadPicture(files: FileList): Promise<string[]>{
    return new Promise((resolve, reject) => {

        const fileHolder = new FormData();

        for(let i = 0; i < files.length; i++){
            fileHolder.append('files', files[i]);
        }

        // files.forEach((file) => {
        //     fileHolder.append('files[]', file);
        // })
        //fileHolder.append('files[]', file);

        axios.post('/articles/upload', fileHolder, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then((response) => {
            return resolve(response.data);
        }).catch((error) => {
            return reject(error);
        });

    });
}
